import { render } from "./advertisementItemDialog.vue?vue&type=template&id=6a553771&scoped=true&ts=true"
import script from "./advertisementItemDialog.vue?vue&type=script&lang=ts"
export * from "./advertisementItemDialog.vue?vue&type=script&lang=ts"

import "./advertisementItemDialog.vue?vue&type=style&index=0&id=6a553771&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a553771"]])

export default __exports__